var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", "max-width": "1000px" } },
    [
      _c(
        "v-card",
        { staticClass: "overflow-x-hidden" },
        [
          _c("v-card-title", [_vm._v(" ARG/Vendor Code of Conduct ")]),
          _c("v-card-text", { staticClass: "mx-4" }, [
            _c("ol", [
              _c("li", [
                _c("strong", [
                  _vm._v(
                    "The vendor/broker maintains responsibility for promo accuracy including but not limited to:"
                  )
                ]),
                _c("ol", { attrs: { type: "a" } }, [
                  _c("li", [_vm._v("Correct net unit cost")]),
                  _vm._v(
                    " • Vendor/broker will be responsible for covering net unit cost differences if changes are received after promotion deadlines "
                  ),
                  _c("li", [_vm._v("Correct group/store inclusion/exclusion")]),
                  _c("li", [_vm._v("Correct Item inclusion/exclusion")]),
                  _c("li", [_vm._v("Correct dates")])
                ])
              ]),
              _c("br"),
              _c("li", [
                _c("strong", [
                  _vm._v(
                    "Vendor/broker will enter deals prior to their submission deadline:"
                  )
                ]),
                _c("ol", { attrs: { type: "a" } }, [
                  _c("li", [
                    _vm._v(" Non-Perishables "),
                    _c("ul", { staticStyle: { "list-style-type": "'• '" } }, [
                      _c("li", [
                        _vm._v(
                          "Ad Deals – To be submitted at time of event window contract submission, absolutely no later than 8 weeks prior to the ad date "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "TPR Deals – To be submitted at time of event window contract submission, absolutely no later than 4 weeks prior to the TPR date"
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Absolutely no promo revisions will be accepted after promotion start date"
                        )
                      ]),
                      _c("li", [
                        _c("strong", [_vm._v("Note: ")]),
                        _vm._v(
                          "Only critical price improvement submissions will be allowed after these deadlines and 2 weeks before execution"
                        )
                      ])
                    ])
                  ]),
                  _c("li", [
                    _vm._v(" Perishable "),
                    _c("ul", { staticStyle: { "list-style-type": "'• '" } }, [
                      _c("li", [
                        _vm._v(
                          "Ad Deals – Submitted at time of event window contract submission, absolutely no later than 4 weeks prior to the ad date"
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "TPR Deals – Submitted at time of event window contract submission, absolutely no later than 4 weeks prior to the TPR date"
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _c("br"),
              _c("li", [
                _c("strong", [
                  _vm._v(
                    "If ARG makes requested changes for Vendor review, Vendor/broker owes response within 48 hours:"
                  )
                ]),
                _c("ol", { attrs: { type: "a" } }, [
                  _c("li", [
                    _vm._v(
                      "Failure to make or discuss requested changes within 48 hours will result in automatic acceptance of change requests"
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c(
            "v-card-actions",
            { staticClass: "mt-8" },
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-row",
                    { staticClass: "mx-4", attrs: { align: "center" } },
                    [
                      _c(
                        "v-btn",
                        {
                          style: _vm.styleObject,
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.logout($event)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { color: "#fff" } },
                            [_vm._v("mdi-logout")]
                          ),
                          _c("span", [_vm._v("Logout")])
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c("v-checkbox", {
                        attrs: { label: "Accept Code of Conduct" },
                        model: {
                          value: _vm.isAccepted,
                          callback: function($$v) {
                            _vm.isAccepted = $$v
                          },
                          expression: "isAccepted"
                        }
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-8",
                          attrs: {
                            disabled: !_vm.isAccepted,
                            color: "primary"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.update($event)
                            }
                          }
                        },
                        [_c("span", [_vm._v("Confirm")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }